import $ from 'jquery';
import eventBus from 'EventBus';
import util from 'util/Util';
import themeService from 'ThemeService';
import undoService from 'UndoService';
import pageSyncService from 'PageSyncService';
import focusController from 'FocusController';
import {pickerCfg} from 'pickerCfg';
import BasePropertyView from 'BasePropertyView';
import formatTemplate from 'properties/theme/groups.ejs';
import assetCollection from 'AssetCollection';
import Immutable        from 'immutable';
import fontService from 'FontService';
class GroupsView extends BasePropertyView {

  initialize(opts) {
    super.initialize(opts);

    this.options = opts || {};
    this.template = formatTemplate;
    this.tagName = 'div';
    this.id = opts.el;

    this.selectedColor = 'lightgrey';
    this.unselectedColor = 'transparent';

    let groupBgImage = !util.isEmpty(themeService.resolve('~groupBgImage')) ? themeService.resolve('~groupBgImage') : '';

    this.initializeTextAttributes();
    this.model.set('groupTitleBg', themeService.resolve('~groupTitleBg'), {silent: true});
    this.initializeBorderAttributes();
    this.model.set('groupBgColor', themeService.resolve('~groupBgColor'), {silent: true});
    this.model.set('groupBgTransparent', themeService.resolve('~groupBgTransparent'), {silent: true});
    this.model.set('groupBgImage', groupBgImage, {silent: true});

    this.events = {
      'change input[type=checkbox]': 'updateCheckAttributes',
      'change input[type=text]': 'updateAttributes',
      'change input[type=color]': 'updateColorAttributes',
      'blur input[type=text]': 'lostFocus',
      'focus input[type=text]': 'getFocus',
      'change select': 'updateSelectAttributes',
      'click .styleSelectorGroup': 'updateTextStyleAttributes',
      'click .weightSelectorGroup': 'updateTextWeightAttributes'
    };

    // Don't change this name without realizing that the base class may assume this name
    this.dropdownPropNames = Immutable.List(
        ['groupFont', 'groupFontSize', 'groupBorderStyle', 'groupBorderSize',
            'groupBorderRadius']);

    return this;
  }

  initializeTextAttributes() {
    this.model.set('groupTextColor', themeService.resolve('~groupTextColor'), {silent: true});

    var fontProp = themeService.resolve('~groupFont').split(',');

    this.model.set('groupFont', fontProp[0].trim(), {silent: true});
    this.model.set('groupFontSize', fontProp[1].trim(), {silent: true});

    if ((fontProp[2] && fontProp[2].toLowerCase().indexOf('bold') > -1) ||
        (fontProp[3] && fontProp[3].toLowerCase().indexOf('bold') > -1)) {
      this.model.set('groupTextWeight', 'bold !important', {silent: true});
    } else {
      this.model.set('groupTextWeight', 'normal !important', {silent: true});
    }
    if (this.model.get('groupTextWeight') === 'normal !important') {
      this.model.set('groupTextWeightSelection', this.unselectedColor, {silent: true});
    } else {
      this.model.set('groupTextWeightSelection', this.selectedColor, {silent: true});
    }

    if ((fontProp[2] && fontProp[2].toLowerCase().indexOf('italic') > -1) ||
        (fontProp[3] && fontProp[3].toLowerCase().indexOf('italic') > -1)) {
      this.model.set('groupTextStyle', 'italic !important', {silent: true});
    } else {
      this.model.set('groupTextStyle', 'normal !important', {silent: true});
    }
    if (this.model.get('groupTextStyle') === 'normal !important') {
      this.model.set('groupTextStyleSelection', this.unselectedColor, {silent: true});
    } else {
      this.model.set('groupTextStyleSelection', this.selectedColor, {silent: true});
    }

  }

  updateThemeFontAttributes() {
    const themePropArray = [this.model.get('groupFont'), this.model.get('groupFontSize'), this.model.get('groupTextWeight'), this.model.get('groupTextStyle')];
    themeService._theme['~groupFont'] = themePropArray.join(',');
  }

  initializeBorderAttributes() {
    this.model.set('groupBorderColor', themeService.resolve('~groupBorderColor'), {silent: true});

    var fontProp = themeService.resolve('~groupBorder').split(',');

    this.model.set('groupBorderSize', fontProp[0].trim(), {silent: true});
    this.model.set('groupBorderStyle', fontProp[1].trim(), {silent: true});
    this.model.set('groupBorderRadius', fontProp[2].trim(), {silent: true});
  }

  updateThemeBorderAttributes() {
    const themePropArray = [this.model.get('groupBorderSize'), this.model.get('groupBorderStyle'), this.model.get('groupBorderRadius')];
    themeService._theme['~groupBorder'] = themePropArray.join(',');
  }

  updateCheckAttributes(ev) {
    ev.preventDefault();
    const propName = ev.currentTarget.name;
    const propVal = ev.currentTarget.checked;
    const oldPropVal = this.model.get(propName);

    this.model.set(propName, propVal, {silent: true});
    themeService._theme['~' + propName] = propVal;
    this.render();
    eventBus.trigger('GroupThemeChange');

    undoService.add({
      undo: () => {
        themeService._theme['~' + propName] = oldPropVal;
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      },
      redo: () => {
        themeService._theme['~' + propName] = propVal;
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      }
    })
  }

  updateTextStyleAttributes(ev) {
    ev.preventDefault();
    const propName = ev.currentTarget.name;

    let style = this.model.get(propName);
    let oldValue = this.model.get(propName);

    if (this.model.get(propName).indexOf('italic') > -1) {
      this.model.set(propName + 'Selection', this.unselectedColor, {silent: true});
      style = 'normal !important';
    } else {
      this.model.set(propName + 'Selection', this.selectedColor, {silent: true});
      style = 'italic !important';
    }

    this.model.set(propName, style, {silent: true});
    this.updateThemeFontAttributes();
    this.render();
    eventBus.trigger('GroupThemeChange');

    undoService.add({
      undo: () => {
        if (oldValue.indexOf('italic') > -1) {
          this.model.set(propName + 'Selection', this.selectedColor, {silent: true});
        } else {
          this.model.set(propName + 'Selection', this.unselectedColor, {silent: true});
        }
        this.model.set(propName, oldValue, {silent: true});
        this.updateThemeFontAttributes();

        //eventBus.trigger('InputThemeChange');
        //this.model.trigger('change', this.model);
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      },
      redo: () => {
        if (style.indexOf('italic') > -1) {
          this.model.set(propName + 'Selection', this.selectedColor, {silent: true});
        } else {
          this.model.set(propName + 'Selection', this.unselectedColor, {silent: true});
        }
        this.model.set(propName, style, {silent: true});
        this.updateThemeFontAttributes();

        //eventBus.trigger('InputThemeChange');
        //this.model.trigger('change', this.model);
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      }
    })
  }

  updateTextWeightAttributes(ev) {
    ev.preventDefault();
    const propName = ev.currentTarget.name;

    let weight = this.model.get(propName);
    let oldValue = this.model.get(propName);

    if (this.model.get(propName).indexOf('bold') > -1) {
      this.model.set(propName + 'Selection', this.unselectedColor, {silent: true});
      weight = 'normal !important';
    } else {
      this.model.set(propName + 'Selection', this.selectedColor, {silent: true});
      weight = 'bold !important';
    }

    this.model.set(propName, weight, {silent: true});
    this.updateThemeFontAttributes();
    eventBus.trigger('GroupThemeChange');
    this.render();

    undoService.add({
      undo: () => {
        if (oldValue.indexOf('bold') > -1) {
          this.model.set(propName + 'Selection', this.selectedColor, {silent: true});
        } else {
          this.model.set(propName + 'Selection', this.unselectedColor, {silent: true});
        }
        this.model.set(propName, oldValue, {silent: true});
        this.updateThemeFontAttributes();

        //eventBus.trigger('InputThemeChange');
        //this.model.trigger('change', this.model);
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      },
      redo: () => {
        if (weight.indexOf('italic') > -1) {
          this.model.set(propName + 'Selection', this.selectedColor, {silent: true});
        } else {
          this.model.set(propName + 'Selection', this.unselectedColor, {silent: true});
        }
        this.model.set(propName, weight, {silent: true});
        this.updateThemeFontAttributes();

        //eventBus.trigger('InputThemeChange');
        //this.model.trigger('change', this.model);
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      }
    })
  }

  updateAttributes(ev) {
    ev.preventDefault();
    const propName = ev.currentTarget.name;
    const propVal = ev.currentTarget.value;
    const oldPropVal = this.model.get(propName);
    const oldThemeValue = themeService._theme['~' + propName];

    if (util.isValidColorcode(propVal)) {
      let color = this.resolveColor(propVal);
      this.model.set(propName, color, {silent: true});
      themeService._theme['~' + propName] = color;
      $('#' + propName).val(color);
      this.addUndoRedoColorAction(propName, oldThemeValue, oldPropVal, color);
      this.render();
      eventBus.trigger('GroupThemeChange');
    }
    else {
      this.render();
    }
  }

  updateColorAttributes(ev) {
    ev.preventDefault();
    const propName = ev.currentTarget.name;
    const propVal = ev.currentTarget.value;
    const oldPropVal = this.model.get(propName);
    const oldThemeValue = themeService._theme['~' + propName];

    let color = this.resolveColor(propVal);
    this.model.set(propName, color, {silent: true});
    themeService._theme['~' + propName] = color;
    $('#' + propName).val(color);
    this.addUndoRedoColorAction(propName, oldThemeValue, oldPropVal, color);
    this.render();
    eventBus.trigger('GroupThemeChange');
  }

  addUndoRedoColorAction(propName,oldThemeValue,oldPropVal,currentColor){
    undoService.add({
      undo:() => {
        this.model.set(propName, oldPropVal,{silent:true});
        themeService._theme['~' + propName] = oldThemeValue;
        //eventBus.trigger('InputThemeChange');
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
        $('#' + propName).val(oldPropVal);
      },
      redo: () => {
        this.model.set(propName, currentColor,{silent:true});
        themeService._theme['~' + propName] = currentColor;
        //eventBus.trigger('InputThemeChange');
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
        $('#' + propName).val(currentColor);
      }
    })
  }

  updateSelectAttributes(ev, name, val) {
    ev.preventDefault();
    const propName = name || ev.currentTarget.name;
    const propVal = val || ev.currentTarget.value;
    const oldPropVal = this.model.get(propName);

    this.model.set(propName, propVal, {silent: true});
    if (propName === 'groupBorderStyle' || propName === 'groupBorderSize' || propName === 'groupBorderRadius') {
      this.updateThemeBorderAttributes();
    } else if (propName === 'groupFont' || propName === 'groupFontSize') {
      this.updateThemeFontAttributes();
    } else if (propName === 'groupBgImage') {
      themeService._theme['~' + propName] = propVal;
    }
    this.render();
    eventBus.trigger('GroupThemeChange');

    undoService.add({
      undo:() => {
        this.model.set(propName, oldPropVal,{silent:true});
        if (propName === 'groupBorderStyle' || propName === 'groupBorderSize' || propName === 'groupBorderRadius') {
          this.updateThemeBorderAttributes();
        } else if (propName === 'groupFont' || propName === 'groupFontSize') {
          this.updateThemeFontAttributes();
        } else if (propName === 'groupBgImage') {
          themeService._theme['~' + propName] = oldPropVal;
        }

        //eventBus.trigger('InputThemeChange');
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      },
      redo: () => {
        this.model.set(propName, propVal,{silent:true});
        if (propName === 'groupBorderStyle' || propName === 'groupBorderSize' || propName === 'groupBorderRadius') {
          this.updateThemeBorderAttributes();
        } else if (propName === 'groupFont' || propName === 'groupFontSize') {
          this.updateThemeFontAttributes();
        } else if (propName === 'groupBgImage') {
          themeService._theme['~' + propName] = propVal;
        }

        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
      }
    })
  }



    updateForm() {
        super.updateForm();

        if (!util.isEmpty(this.model.get('groupBgImage'))) {
            $('#groupBgImage').find(`option[value='${this.model.get('groupBgImage')}']`).attr('selected', true);

            const ddValue = this.model.get('groupBgImage');
            $('#groupBgImage').val(ddValue);
        } else {
            $('#groupBgImage').val('None');
        }
    }


  render() {
    super.render();

    if (this.template) {
      this.$el.html(this.template(this.model.toJSON()));
      assetCollection.forEach(asset => {
        var opt = document.createElement('option');
        opt.text = asset.get('name');
        opt.value = asset.get('id');
        $('#groupBgImage').append(opt);
      });
    }

    util.prepareComboWidget(this.$el, this);

    this.createEditableDropDown('groupFontSize');
    this.createEditableDropDown('groupBorderSize');
    this.createEditableDropDown('groupBorderRadius');

    this.checkBorderDropDown('#groupBorderSize', 'groupBorderStyle');
    this.checkBorderDropDown('#groupBorderRadius', 'groupBorderStyle');

    const fonts = fontService.loadFontsDropDown(false);
    $("#groupFont").append(fonts);


    //.$('input[type=color]', this.$el).spectrum(pickerCfg);

    this.updateForm();
    this.delegateEvents();
    return this;
  }

}

export default GroupsView;
